module.exports = __webpack_public_path__ + "media/images/identity_icono_1-2afbb3c5.jpg";